import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import UseCaseDetailsFrame from 'src/components/use-case-details-frame'
import PillButton from 'src/components/pill-button'
import TextButton from 'src/components/text-button'
import TapAnimation from 'src/components/tap-animation'
import PhoneContainer from 'src/components/phone-container'
import content1Src from 'src/assets/use-case-5-content-1.png'
import content2Src from 'src/assets/use-case-5-content-2.png'
import content3Src from 'src/assets/use-case-5-content-3.png'
import content4Src from 'src/assets/use-case-5-content-4.png'
import content5SrcA from 'src/assets/use-case-5-content-5-a.png'
import content5SrcB from 'src/assets/use-case-5-content-5-b.png'
import content6Src from 'src/assets/use-case-5-content-6.png'
import content7SrcA from 'src/assets/use-case-5-content-7-a.png'
import content7SrcB from 'src/assets/use-case-5-content-7-b.png'

export class UseCase5Frame1 extends Component {
  static propTypes = {
    className: PropTypes.string,
    useCase: PropTypes.object.isRequired,
    back: PropTypes.func.isRequired,
    tapDelay: PropTypes.number,
  }

  static defaultProps = {
    className: '',
    tapDelay: 500,
  }

  state = {
    contentId: 'content-1',
    shouldTap1: false,
    onTapComplete: () => {},
  }

  get className() {
    const { className } = this.props
    return c('im-use-case-5-frame-1', className)
  }

  render() {
    const { className } = this
    const { useCase, back, tapDelay } = this.props
    const { contentId, shouldTap1, onTapComplete } = this.state
    const { content1, content2, content3, content4, content5, content6, content7 } = useCase
    return (
      <UseCaseDetailsFrame className={className} back={back} useCase={useCase}>
        <section className={c('content content-1', contentId === 'content-1' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h3>{content1.copy1}</h3>
              <h2>{content1.copy2}</h2>
            </section>
            <section className="pill-buttons">
              <PillButton
                onClick={() => {
                  this.setState({ forceIndex: 0 })
                  setTimeout(() => {
                    this.setState({
                      shouldTap1: true,
                      onTapComplete: () => {
                        this.setState({ contentId: 'content-3', shouldTap1: false })
                      },
                    })
                  }, tapDelay)
                }}>
                {content1.button1}
              </PillButton>
              <PillButton
                onClick={() => {
                  this.setState({ forceIndex: 0 })
                  setTimeout(() => {
                    this.setState({
                      shouldTap1: true,
                      onTapComplete: () => {
                        this.setState({ contentId: 'content-2', shouldTap1: false })
                      },
                    })
                  }, tapDelay)
                }}>
                {content1.button2}
              </PillButton>
            </section>
          </section>
          <section className="device-container">
            <PhoneContainer src={content1Src}>
              <TapAnimation className="tap-1" shouldTap={shouldTap1} onTapComplete={onTapComplete} />
            </PhoneContainer>
          </section>
        </section>
        <section className={c('content content-2', contentId === 'content-2' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content2.copy1}</h2>
            </section>
            <section className="pill-buttons with-text-buttons">
              <PillButton onClick={() => this.setState({ contentId: 'content-5' })}>
                {content2.button1}
              </PillButton>
              <PillButton onClick={() => this.setState({ contentId: 'content-4' })}>
                {content2.button2}
              </PillButton>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content2.button3}
              </TextButton>
            </section>
          </section>
          <section className="device-container no-fade">
            <PhoneContainer showLoader={true} src={content2Src} />
          </section>
        </section>
        <section className={c('content content-3', contentId === 'content-3' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content3.copy1}</h2>
            </section>
            <section className="pill-buttons with-text-buttons">
              <PillButton onClick={() => this.setState({ contentId: 'content-7' })}>
                {content3.button1}
              </PillButton>
              <PillButton onClick={() => this.setState({ contentId: 'content-6' })}>
                {content3.button2}
              </PillButton>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content3.button3}
              </TextButton>
            </section>
          </section>
          <section className="device-container no-fade">
            <PhoneContainer showLoader={true} src={content3Src} />
          </section>
        </section>
        <section className={c('content content-4', contentId === 'content-4' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content4.copy1}</h2>
              <p>{content4.copy2}</p>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content4.button1}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <PhoneContainer src={content4Src} />
          </section>
        </section>
        <section className={c('content content-5', contentId === 'content-5' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content5.copy1}</h2>
              <p>{content5.copy2}</p>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content5.button1}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <PhoneContainer showBackground={true} src={[content5SrcA, content5SrcB]} />
          </section>
        </section>
        <section className={c('content content-6', contentId === 'content-6' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content6.copy1}</h2>
              <p>{content6.copy2}</p>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content6.button1}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <PhoneContainer src={content6Src} />
          </section>
        </section>
        <section className={c('content content-7', contentId === 'content-7' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content7.copy1}</h2>
              <p>{content7.copy2}</p>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content7.button1}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <PhoneContainer showBackground={true} src={[content7SrcA, content7SrcB]} />
          </section>
        </section>
      </UseCaseDetailsFrame>
    )
  }
}

export default UseCase5Frame1
